import React from 'react';

const IconFork = () => (
  <svg>
  
  </svg>
);

export default IconFork;
